import { render, staticRenderFns } from "./SpeechBubble.vue?vue&type=template&id=4c7d2b7c&scoped=true&"
import script from "./SpeechBubble.vue?vue&type=script&lang=js&"
export * from "./SpeechBubble.vue?vue&type=script&lang=js&"
import style0 from "./SpeechBubble.vue?vue&type=style&index=0&id=4c7d2b7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7d2b7c",
  null
  
)

export default component.exports